import {Avatar, Box, Badge, Stack, Divider, ListItemButton, ListItemAvatar, ListItemText, Typography, useTheme} from "@mui/material";
import { tokens } from "../../theme";
import {Fragment, useContext} from "react";
// import ProgressCircle from "./ProgressCircle";
import { styled, alpha } from "@mui/material/styles";
import {Context} from "../../index";
import truncateString from "../../utils/trancate";
import { fToNow, fTime } from "../../utils/formatTime";


const StyledElementBox = styled(Box)(({ theme }) => ({
    "&:hover": {
        cursor: "pointer",
    },
}));

const UserResultElement = ({ user, handleClick}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // const {store} = useContext(Context);
    // const selectedChatId = store.appealId?.toString();
    // let isSelected = +selectedChatId === id;

    // if (!selectedChatId) {
    //     isSelected = false;
    // }
    return (
        <StyledElementBox
            onClick={() => {
                handleClick({
                    object_type: "user",
                    object: user.billing_id + ":" + user.user_id,
                });
            }}
            sx={{
                width: "100%",
                p: 1,
                borderRadius: 1,

                // backgroundColor: id == selectedChatId
                //     ? theme.palette.mode === "light"
                //         ? alpha(theme.palette.primary.main, 0.5)
                //         : theme.palette.primary.main
                //     : theme.palette.mode === "light"
                //         ? "#fff"
                //         : theme.palette.background.paper,
            }}
            p={2}
        >
            <Typography variant="subtitle2">{user.user_id} {user.login} {user.full_name}</Typography>
        </StyledElementBox>
    );
};

export default UserResultElement;